import React, {ReactElement} from 'react';

type SuccessToastProps = {
  title: string;
  description: string;
};

const SuccessToast: React.FC<SuccessToastProps> = ({
  title,
  description,
}: //body,
SuccessToastProps): ReactElement => {
  return (
    <div>
      <div className="font-bold bg-green_zero px-6 pt-4 pb-2 bg-opacity-10 rounded-t-xl flex items-center">
        <div>
          <svg
            className="w-4 h-4 text-white rounded-full bg-green_zero"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        <div className="ml-2 font-roboto font-bold">{title}</div>
      </div>
      <div className="bg-opacity-10 rounded-b-xl pt-2 pb-4 px-4">
        {description}
      </div>
    </div>
  );
};

export default SuccessToast;
